import {
  DialogContent,
  DialogContentText,
  List,
  ListItemButton,
  ListItemText,
  Box,
} from "@mui/material";
import { BaseDialog } from "./base";

export function SelectDialog({
  open,
  title,
  description,
  options = [],
  selectedValue = null,
  allowClickAwayClose = true,
  disableInteraction = false,
  onSelect,
  onClose,
}) {
  const handleOptionClick = (option) => {
    if (disableInteraction) return; // Don't handle clicks if disabled
    onSelect(option);
  };

  // Handle backdrop and escape key - only close if allowed
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      if (!allowClickAwayClose) {
        return; // Don't close
      }
    }
    onClose();
  };

  return (
    <BaseDialog open={open} onClose={handleClose} title={title}>
      
      <DialogContent sx={{ pb: 2 }}>
        {description && (
          <DialogContentText sx={{ mb: 2 }}>
            {description}
          </DialogContentText>
        )}
        <Box sx={{ width: '100%', minWidth: 300 }}>
          <List disablePadding dense>
            {options.map((option, index) => {
              const isSelected = selectedValue === option.value;
              
              return (
                <ListItemButton
                  key={option.value || index}
                  selected={isSelected}
                  onClick={() => handleOptionClick(option)}
                  // disabled={disableInteraction}
                  sx={{
                    px: 0.5,
                    py: 0.5,
                    borderRadius: 2,
                    cursor: disableInteraction ? 'not-allowed' : 'pointer',
                    pointerEvents: disableInteraction ? 'none' : 'auto',
                    '&:last-child': { mb: 0 },
                    '&.Mui-selected': {
                      backgroundColor: 'primary.main',
                      color: 'primary.contrastText',
                      '&:hover': {
                        backgroundColor: disableInteraction 
                          ? 'primary.main' 
                          : 'primary.dark',
                      }
                    },
                    '&:hover': {
                      backgroundColor: disableInteraction 
                        ? 'transparent' 
                        : isSelected 
                          ? 'primary.dark' 
                          : 'action.hover'
                    },
                    '&.Mui-disabled': {
                      opacity: disableInteraction ? 0.6 : 1,
                    }
                  }}
                >
                  <ListItemText 
                    primary={option.label} 
                    secondary={option.description}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Box>
      </DialogContent>
    </BaseDialog>
  );
}